import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'mui-rff';

import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

const SeoBlockFaqItem = ({ blockName, onBlur, onRemove, canRemove = true }) => {
	return (
		<>
			<Grid item xs={12} md={4}>
				<TextField
					name={`${blockName}.question`}
					label="Question"
					variant="outlined"
					size="small"
					onBlur={onBlur}
					fullWidth
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					name={`${blockName}.answer`}
					label="Answer"
					variant="outlined"
					size="small"
					multiline
					rows={3}
					onBlur={onBlur}
					fullWidth
				/>
			</Grid>
			<Grid item xs={12} md={2}>
				<IconButton
					onClick={onRemove}
					disabled={!canRemove}
				>
					<DeleteOutlineOutlinedIcon />
				</IconButton>
			</Grid>
		</>
	);
};

SeoBlockFaqItem.propTypes = {
	blockName: PropTypes.string.isRequired,
	onBlur: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired,
	canRemove: PropTypes.bool
};

export default SeoBlockFaqItem;
